export default "__VITE_ASSET___5A8wCAL__"